export const permissionList = {
  dashboard: "dashboard",
  locations: "locations",
  agents: "agents",
  hotels: "agents",
  services: "agents",
  b2bUsers: "admin-b2b-users",
  b2bMarkups: "markups",
  b2bAgentSetup: "admin-b2b-agent-setup",
  chat: "reservation-chat",
  b2bNewReservations: "b2b-new-reservation",
  b2bNewReservationHotel: "b2b-new-reservation-hotel",
  b2bNewReservationService: "b2b-new-reservation-service",
  b2bNewReservationTransfer: "b2b-new-reservation-transfer",
  b2bMyReservations: "b2b-my-reservations",
  backOfficeViewReservations: "bo-view-reservations",
};
